import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";

const useRemoveDealSubCampaign = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const removeDealSubCampaign = async (params = {}) => {
        setLoading(true);
        setError(null);

        const { dealId, campaignId } = params;

        if (!dealId || !campaignId) {
            const errorMessage = "Deal ID and Campaign ID are required";
            setError(errorMessage);
            setLoading(false);
            toast.error(errorMessage);
            return { error: errorMessage };
        }

        const payload = {
            fn: "removeDealSubCampaign",
            dealId,
            campaignId,
        };

        try {
            const response = await post(payload);
            toast.success("Sub campaign cancelled successfully");
            return { data: response.data };
        } catch (error) {
            const errorMessage = error?.response?.data?.text || error?.message || "An unexpected error occurred";
            setError(errorMessage);
            toast.error(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { removeDealSubCampaign, loading, error };
};

export default useRemoveDealSubCampaign;
